import * as React from 'react';
import { Card } from 'components';

const PageCopy = ({
  iconUrl,
  heading,
  copy,
  ...rest
}: {
  iconUrl: string,
  heading?: string,
  copy: string,
}) => (
  <Card className="pa4 flex flex-row items-center" {...rest}>
    <img src={iconUrl} height="80" alt="" aria-hidden="true" className="mr3" />
    <div>
      {heading && (
        <h3 className="f3 brandon dark-gray mt0 mb2 pb1 lh-solid">{heading}</h3>
      )}
      <p className="mv0 gray lh-copy">{copy}</p>
    </div>
  </Card>
);

export default PageCopy;



// WEBPACK FOOTER //
// ./src/components/FeatureBanner.js